import { render, staticRenderFns } from "./PrintGeneralLedger.vue?vue&type=template&id=55bd3270&scoped=true"
import script from "./PrintGeneralLedger.vue?vue&type=script&lang=js"
export * from "./PrintGeneralLedger.vue?vue&type=script&lang=js"
import style0 from "./PrintGeneralLedger.vue?vue&type=style&index=0&id=55bd3270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd3270",
  null
  
)

export default component.exports